import React from 'react';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';

import TextField from '@material-ui/core/TextField';

import PickupOrder from '../../../models/PickupOrder';

import style from '../orders/ordersStyle.module.css';
import commonStyles from '../../common/common.module.css';

import CommonTruckerLockedContainer from './truckerLocked/CommonTruckerLockedContainer';

const TEXT_FIELD_PADDINGS: string = '6px 12px';

const styles = (theme: Theme) =>

  createStyles({

    textField45: {
        marginRight: '20px',
        '&:last-child':{
          marginRight: 0 ,
      }
    },
    textField: {
      marginBottom: '20px',
      '& input': {
        color: 'var(--primaryblue)',
        fontSize: '13px'
      },
      '& fieldset': {
        borderRadius: '20px'
      },
    },
  });

interface CommonOrderDriverTextFieldsProps {
  classes: any;
  pickupOrder: PickupOrder;
  handleChange: (fieldName: string, event: any) => void;
  setContainerState?: (data: any) => void;
};

const commonOrderDriverTextFields = (props: CommonOrderDriverTextFieldsProps) => {

  const { classes, pickupOrder } = props;
  const disabled: boolean = !pickupOrder.allowed_ops.update_dispatch_driver_details;

  return (
    <div className={ [style.driverWrapper, style.mainWrapperTruckingInfo].join(' ') }>

      <div className={ commonStyles.inputLabelWrapper } >
        <label className={ commonStyles.inputLabel }> Driver's Name </label>
        <TextField
          label=""
          className={ [classes.widthWrapper, classes.textField].join(' ') }
          variant="outlined"
          value={ pickupOrder.driver_name }
          onChange={ (event) => props.handleChange('driverName', event) }
          inputProps={{ style: { padding: TEXT_FIELD_PADDINGS } }}
          InputLabelProps={{ shrink: true }}
          disabled={ disabled }
        />
      </div>
      
      <div className={ [style.flex, classes.widthWrapper].join(' ') }>
        <div className={ commonStyles.inputLabelWrapper } >
          <label className={ commonStyles.inputLabel }> Driver's ID type  </label>
          <TextField
            label=""
            className={ [classes.textField45, classes.textField].join(' ')}
            variant="outlined"
            value={ pickupOrder.driver_id_type }
            onChange={ (event) => props.handleChange('driverIdType', event) }
            inputProps={{ style: { padding: TEXT_FIELD_PADDINGS } }}
            InputLabelProps={{ shrink: true }}
            disabled={ disabled }
            style={{paddingRight: 20}}
          />
        </div>
        
        <div className={ commonStyles.inputLabelWrapper } >
          <label className={ commonStyles.inputLabel }> Driver's ID </label>
          <TextField
            label=""
            className={ [classes.textField45, classes.textField].join(' ') }
            variant="outlined"
            value={ pickupOrder.driver_id }
            onChange={ (event) => props.handleChange('driverId', event) }
            inputProps={{ style: { padding: TEXT_FIELD_PADDINGS } }}
            InputLabelProps={{ shrink: true }}
            disabled={ disabled }
          />
        </div>       
      </div>

      <div className={ commonStyles.inputLabelWrapper } >
        <label className={ commonStyles.inputLabel }>Truck Plate Number</label>
        <TextField
          label=""
          className={ [classes.widthWrapper, classes.textField].join(' ')}
          variant="outlined"
          value={ pickupOrder.driver_vehichle_registration }
          onChange={ (event) => props.handleChange('driverVehichleRegistration', event) }
          inputProps={{ style: { padding: TEXT_FIELD_PADDINGS } }}
          InputLabelProps={{ shrink: true }}
          disabled={ disabled }
        />
      </div>     

      <div className={ style.lockedComponentWrapper }>
        { pickupOrder.order_type === 'do' && 
          <CommonTruckerLockedContainer
            dropOffOrder={ pickupOrder }
            sealNumberMandatory={ true }
            setContainerState={ props.setContainerState }
            view='driverTextField'
            editable={ true }
          />
        }
      </div>

    </div>
  );
}

export default withStyles(styles)(commonOrderDriverTextFields);